

export const ProductInstanceView = (data) => <></>